import React from "react";
import { CameraTeaserElement } from "../../../../content-elements/teaser/CameraTeaser/CameraTeaserElement/CameraTeaserElement";

export function CameraListElement({ camera, currency }) {
    return (
        <CameraTeaserElement
            key={camera.id}
            data={camera}
            semanticOfTeaserHeadline={"H3"}
            currency={currency}
            originalId={camera.originalId}
            hasLightBackground
        />
    );
}
